import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { constellationData } from '../data/constellationData';
import ConstellationIcon from '../components/icons/ConstellationIcon';
import './SearchPage.css';

const SearchPage = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q')?.toLowerCase() || '';

  const searchResults = Object.entries(constellationData)
    .filter(([name, data]) => 
      name.toLowerCase().includes(query) || 
      data.chineseName.includes(query)
    )
    .map(([name, data]) => ({ name, ...data }));

  return (
    <div className="search-page">
      <h1>搜索结果: "{query}"</h1>
      <div className="results-grid">
        {searchResults.length > 0 ? (
          searchResults.map(item => (
            <Link to={`/constellation/${item.name}`} key={item.name} className="result-card">
              <ConstellationIcon name={item.name} width="80" height="80" />
              <h3>{item.chineseName}</h3>
              <p>{item.name}</p>
            </Link>
          ))
        ) : (
          <p>没有找到匹配的星座。</p>
        )}
      </div>
    </div>
  );
};

export default SearchPage;
